import { Component } from '@angular/core'

import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router'

import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import {

    faAnglesLeft,

    faAnglesRight,

    faBoxOpen,

    faCartShopping,

    faFileInvoiceDollar,

    faFileLines,

    faGauge,

    faScaleBalanced,

} from '@fortawesome/free-solid-svg-icons'



import { BaseComponent } from '../../shared'

import { FeatureType } from '../../shared/enums'



const SIDEBAR_COLLAPSED_KEY = 'purchasing.sidebarCollapsed'



@Component({

    selector: 'app-purchasing-layout',

    templateUrl: './purchasing-layout.component.html',

    styleUrls: ['./purchasing-layout.component.css'],

    standalone: true,

    imports: [RouterLink, RouterLinkActive, RouterOutlet, FaIconComponent],

})

export class PurchasingLayoutComponent extends BaseComponent {

    public featureType = FeatureType



    public collapsed = false



    faGauge = faGauge

    faFileLines = faFileLines

    faCartShopping = faCartShopping

    faBoxOpen = faBoxOpen

    faFileInvoiceDollar = faFileInvoiceDollar

    faScaleBalanced = faScaleBalanced

    faAnglesLeft = faAnglesLeft

    faAnglesRight = faAnglesRight



    constructor() {

        super()

        this.isInitialLoading = false

        try {

            this.collapsed = localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true'

        } catch {

            this.collapsed = false

        }

    }



    public canView(...features: FeatureType[]): boolean {

        return this.services.authentication.hasFeature(features)

    }



    public toggleCollapsed(): void {

        this.collapsed = !this.collapsed

        try {

            localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(this.collapsed))

        } catch {

            // ignore storage errors

        }

    }

}


